import { ShieldCheck, EyeOff, Lock, UserCheck, Cpu } from 'lucide-react';
import styles from './SafetySection.module.css';

export const SafetySection = () => {
  return (
    <section id="safety" className={styles.section}>
      <div className="wrap">
        <div className="section-header">
          <div className="section-label">Trust & Safety</div>
          <h2>Your Privacy is Non-Negotiable</h2>
          <p>We built PCCheckr to be the safest way to diagnose Windows issues.</p>
        </div>

        <div className={styles.grid}>
          <div className={styles.card}>
            <div className={styles.icon}><Lock size={24} /></div>
            <h3>No Passwords Collected</h3>
            <p>We never ask for your Windows password, Microsoft login, or any sensitive credentials.</p>
          </div>

          <div className={styles.card}>
            <div className={styles.icon}><EyeOff size={24} /></div>
            <h3>No Personal Files Accessed</h3>
            <p>Our tools only read system-level metadata. Your photos, documents, and history remain private.</p>
          </div>

          <div className={styles.card}>
            <div className={styles.icon}><ShieldCheck size={24} /></div>
            <h3>Read-Only Analysis</h3>
            <p>Diagnostics are read-only. We don't make automated changes to your registry or system files.</p>
          </div>

          <div className={styles.card}>
            <div className={styles.icon}><UserCheck size={24} /></div>
            <h3>Full User Control</h3>
            <p>You choose what data to upload. Reports are AI-assisted guidance, and you decide which fixes to apply.</p>
          </div>

          <div className={styles.card}>
            <div className={styles.icon}><Cpu size={24} /></div>
            <h3>Non-Destructive AI</h3>
            <p>Our AI analysis identifies root causes and provides safe, verified instructions to fix them manually.</p>
          </div>
        </div>
      </div>
    </section>
  );
};
